import {Collaborator} from "./Collaborator";


export type AppendableCollaboratorType = 'editor' | 'viewer';

export function isAppendableCollaboratorType(collaborator_type: any): collaborator_type is AppendableCollaboratorType {
    return collaborator_type === 'editor' || collaborator_type === 'viewer';
}

export type ChangeableCollaboratorType = AppendableCollaboratorType | 'deleted';

export function isChangeableCollaboratorType(collaborator_type: any): collaborator_type is AppendableCollaboratorType {
    return isAppendableCollaboratorType(collaborator_type) || collaborator_type === 'deleted';
}

const MAX_COLLABORATOR = 30; // 無制限に追加されるのを防止するために設定

export class CollaboratorList {

    private readonly collaborators: Collaborator[] = [];


    constructor(collaborators: Collaborator[]) {
        if (MAX_COLLABORATOR < collaborators.length) {
            throw new Error("over collaborator limit");
        }

        this.collaborators = collaborators;
    }

    exists(user: string): boolean {
        return this.collaborators.find(c => c.User === user) !== undefined;
    }

    mergeArray(add_collaborators: Collaborator[]): CollaboratorList {
        const new_collaborators = Array.from(this.collaborators);
        add_collaborators.forEach(add_c => {
            if (new_collaborators.find(c => c.User === add_c.User) === undefined) {
                new_collaborators.push(add_c);
            }
        });
        return new CollaboratorList(new_collaborators);
    }

    addCollaborator(collaborator: Collaborator): CollaboratorList {
        if (this.exists(collaborator.User)) {
            throw new Error('already exists');
        }

        const new_collaborators = Array.from(this.collaborators);
        new_collaborators.push(collaborator);
        return new CollaboratorList(new_collaborators);
    }

    changeType(user: string, type: ChangeableCollaboratorType): CollaboratorList {

        const collaborators = Array.from(this.collaborators);

        const index = collaborators.findIndex(c => c.User === user);
        if (index === -1) {
            throw new Error(`no user: ${user}`);
        }

        if (type === 'deleted') {
            collaborators.splice(index, 1);
        } else {
            collaborators[index] = collaborators[index].changeType(type);
        }

        return new CollaboratorList(collaborators);
    }

    list<U>(callbackfn: (c: Collaborator) => U): U[] {
        return this.collaborators.map(c => callbackfn(c));
    }

    toApplyCollaboratorsArray(): { user: string, type: string }[] {
        return this.collaborators.filter(c => c.Type !== 'owner').map(c => 0 || {user: c.User, type: c.Type});
    }

    static createEmpty(): CollaboratorList {
        return new CollaboratorList([]);
    }

}
